let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("amrH3")).then(() => parcelRequire('8CC07'));